import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Label from 'src/components/atoms/label/label';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { changePassword } from 'src/reducers/updatePassword.reducer';
import { validationSchema } from 'src/utils/validation-utils';
import Spinner from 'src/components/atoms/spinner/spinner';
import { Heading } from '../../atoms/heading/heading';

export const ChangePassword = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const id = Number(params.id);

  const { loading } = useAppSelector(state => state.changepassword);

  const {
    register,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { oldPassword: '', newPassword: '', confirmPassword: '', id: id },
  });

  const onSubmit = () => {
    dispatch(changePassword(getValues()));
  };

  return (
    <div className="container sm m-auto">
      <Heading content="Cambia password" size={2} className="mb-1" />
      <Form>
        <FormRow>
          <FormItem>
            <Label>Inserisci la tua password attuale</Label>
            <input
              type="password"
              placeholder="Password attuale"
              autoComplete="off"
              className={`form-control ${errors.oldPassword ? 'is-invalid' : ''}`}
              {...register('oldPassword', validationSchema.required)}
            />
            <FormError error={errors.oldPassword} validation={validationSchema.password} />
          </FormItem>
          <FormItem>
            <Label>Inserisci la tua nuova password</Label>
            <input
              type="password"
              placeholder="Nuova password"
              autoComplete="off"
              className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
              {...register('newPassword', validationSchema.password)}
            />
            <FormError error={errors.newPassword} validation={validationSchema.password} />
          </FormItem>
          <FormItem>
            <Label>Conferma la tua nuova password</Label>
            <input
              type="password"
              placeholder="Ripeti nuova password"
              autoComplete="off"
              className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
              {...register('confirmPassword', validationSchema.confirmPassword)}
            />
            <FormError error={errors.confirmPassword} validation={validationSchema.confirmPassword} />
          </FormItem>
        </FormRow>
        <FormRow col="2">
          <FormItem>
            <Button onClick={() => navigate('/')} size="md" rounded="rounded-md" color="light-grey" mode="outline" fullWidth>
              Annulla
            </Button>
          </FormItem>
          <FormItem>
            <Button onClick={onSubmit} size="md" rounded="rounded-md" color="black" mode="solid" fullWidth disabled={!isValid || loading}>
              {loading ? <Spinner color="white" /> : 'Cambia password'}
            </Button>
          </FormItem>
        </FormRow>
      </Form>
    </div>
  );
};
